import { ApiClientEnterprise } from '@helpers/apiClients';
import CheckIcon from '@mui/icons-material/Check';
import { LoadingButton } from '@mui/lab';
import { API_LINK_MANAGEMENT_URL } from '@organisms/Tables/Enterprise/LinksManagementTable/constants';
import { ITableLinksManagement } from '@organisms/Tables/Enterprise/LinksManagementTable/types';
import { errorMessage, successMessage } from '@services';
import { AxiosError } from 'axios';
import React, { FC } from 'react';
import { useMutation } from 'react-query';
import { useParams } from 'react-router-dom';
import { DEFAULT_TOAST_MESSAGE } from '../constants';
import { IEditLinkManagementData } from '../types';
import { getErrorMessageLinkManagement } from '../utils';
import { Tooltip } from '@mui/material';

interface ILinkManagementSaveBtnprops {
  savedDataSelectedRow: any;
  multipleValue: ITableLinksManagement[];
  refetch: () => void;
}

const LinkManagementSaveBtn: FC<ILinkManagementSaveBtnprops> = ({
  savedDataSelectedRow,
  multipleValue,
  refetch,
}) => {
  const { id: organizationId } = useParams<{ id: string }>();

  const handleSuccess = () => {
    refetch();
    successMessage(DEFAULT_TOAST_MESSAGE.UPDATE.SUCCESS);
  };

  const handleError = (error: AxiosError) => {
    const errorMsg = getErrorMessageLinkManagement(error.response?.data?.errorMessage);
    errorMessage(errorMsg);
  };

  const { mutate: save, isLoading: isLoadingSave } = useMutation<
    unknown,
    AxiosError,
    IEditLinkManagementData
  >(
    (data) =>
      ApiClientEnterprise.patch(`${API_LINK_MANAGEMENT_URL}${organizationId}/links`, { ...data }),
    {
      onSuccess: handleSuccess,
      onError: handleError,
    },
  );

  const handleSaveLinkManagement = () => {
    if (savedDataSelectedRow) {
      const listIds = multipleValue.map((value) => value.id);
      const data = {
        ...savedDataSelectedRow,
        ids: listIds,
      };
      save({ ...data });
    }
  };

  return (
    <Tooltip title="Save">
      <LoadingButton
        onClick={handleSaveLinkManagement}
        color="primary"
        startIcon={<CheckIcon fontSize="small" />}
        loading={isLoadingSave}
        sx={{
          padding: 0,
          minWidth: '30px',
          '& > span': {
            margin: 0,
          },
        }}
      />
    </Tooltip>
  );
};

export default React.memo(LinkManagementSaveBtn);
